import { DASHBOARD_DEVICES, DASHBOARD_DEVICES_SUCCESS, DASHBOARD_DEVICES_ERROR, DASHBOARD_DEVICES_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const DashboardDevices = (state = initialState, action) => {
  switch (action.type) {
    case DASHBOARD_DEVICES:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case DASHBOARD_DEVICES_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case DASHBOARD_DEVICES_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case DASHBOARD_DEVICES_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default DashboardDevices;
